module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dragon-tiger-rank-v2"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trophy",
      "size": "32",
      "color": "#f39c12"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("龙虎榜")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("销售部业绩排行榜")])], 1), _vm._v(" "), (_vm.newOrderList.length > 0) ? _c('div', {
    staticClass: "news-marquee"
  }, [_c('div', {
    staticClass: "marquee-content"
  }, _vm._l((_vm.newOrderList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "marquee-item"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-notifications",
        "size": "14",
        "color": "#ff9900"
      }
    }), _vm._v("\n              " + _vm._s(item) + " 🎉🎉🎉\n            ")], 1)
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('Card', {
    staticClass: "search-card"
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "月份"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.month),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "month", $$v)
      },
      expression: "queryParam.month"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择部门",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.adviserGroup),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserGroup", $$v)
      },
      expression: "queryParam.adviserGroup"
    }
  }, _vm._l((_vm.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserId"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser",
      "not-in-id": [474, 468]
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "师资",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择渠道来源",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "xs": 12,
      "sm": 6,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n                搜索\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "rank-card"
  }, [_c('div', {
    staticClass: "rank-card-header"
  }, [_c('span', {
    staticClass: "rank-title"
  }, [_vm._v("排行榜")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download-outline",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportToImage
    }
  }, [_vm._v("\n            导出图片\n          ")])], 1), _vm._v(" "), _c('div', {
    ref: "exportArea",
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "rank-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "rank-col"
  }, [_vm._v("排名")]), _vm._v(" "), _c('th', {
    staticClass: "dept-col"
  }, [_vm._v("部门")]), _vm._v(" "), _c('th', {
    staticClass: "name-col"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticClass: "quantity-col"
  }, [_vm._v("单量")]), _vm._v(" "), _c('th', {
    staticClass: "amount-col"
  }, [_vm._v("业绩")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rankingData), function(item, index) {
    return _c('tr', {
      key: index,
      class: ['rank-row', _vm.getRankClass(item.rank)]
    }, [_c('td', {
      staticClass: "rank-col"
    }, [_c('div', {
      staticClass: "rank-badge",
      class: _vm.getMedalClass(item.rank)
    }, [(item.rank <= 3) ? _c('span', [_vm._v(_vm._s(_vm.getMedalIcon(item.rank)))]) : _c('span', [_vm._v(_vm._s(item.rank))])])]), _vm._v(" "), _c('td', {
      staticClass: "dept-col"
    }, [_vm._v(_vm._s(_vm.getDepartmentText(item.department)))]), _vm._v(" "), _c('td', {
      staticClass: "name-col"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.goToPerformanceDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.adviserName))])]), _vm._v(" "), _c('td', {
      staticClass: "quantity-col"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "amount-col"
    }, [_vm._v("¥ " + _vm._s(_vm.$numeral(item.amount).format('0,0')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-row"
  }, [_c('td', {
    staticClass: "total-col total-label",
    attrs: {
      "colspan": "3"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#2d8cf0",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.goToTotalPerformanceDetail
    }
  }, [_c('strong', [_vm._v("Total")])])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalQuantity))])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  }, [_c('strong', [_vm._v("¥ " + _vm._s(_vm.$numeral(_vm.totalAmount).format('0,0')))])]), _vm._v(" "), _c('td', {
    staticClass: "total-col"
  })])], 2)])]), _vm._v(" "), (_vm.rankingData.length === 0 && !_vm.searchLoading) ? _c('div', {
    staticClass: "empty-data"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-inbox",
      "size": "60",
      "color": "#dcdee2"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])], 1) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e767812","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/DragonTigerListV2.vue
// module id = 1819
// module chunks = 8